<template>
    <div class="backdrop" @click.self="onClose">
        <div class="report-modal">
            <div>
                <RangeSelector @on-view="onView" @on-close="onClose" @on-date-change="dataReport=null" />
            </div>
            <div style="background: white;height:80%" v-show="dataReport != null">
                <VueApexCharts width="100%" height="100%" :options="chartOptions" :series="series" />
            </div>
        </div>
    </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import { getCurrentInstance } from "@vue/runtime-core";
import { storage } from "@/common/storage";
import RangeSelector from "@/views/components/Reports/RangeSelector.vue";
import apiReport from "@/api/apiReport";

import VueApexCharts from "vue3-apexcharts";
import Utilities from "@/common/utilities";

export default {
    components: {
        VueApexCharts,
        RangeSelector
    },
    props: ["getMinutes",],
    setup(props, { emit }) {
        const emitter = getCurrentInstance().appContext.app.config.globalProperties.emitter;
        const fetchingData = ref(true);

        const chartOptions = ref();
        const series = ref();
        const dataReport = ref();

        const reportTitle = props.getMinutes ? "Sales Collected by Source/Time" :  "Sales Collected by Source/Bucket";
        const reportfilename = props.getMinutes ? "SalesCollectedbySourceTime" :  "SalesCollectedbySourceBucket";
        const yAxisLabel = "Income";
        const xAxisLabel = "Source/Size";
        // const color = "#FF044B";

        const onClose = () => {
            dataReport.value = null;
            emit("on-close");
        };

        const onView = async () => {
            try {
                fetchingData.value = true;
                emitter.emit("server-call-start", "Loading...");

                dataReport.value = await apiReport.dispenseSummaryDollars(storage.getReportDateStart(), storage.getReportDateEnd(), props.getMinutes);
                populateChart();
            } catch (err) {
                console.log("ERROR:", err);
                emitter.emit("show-alert", ["Error loading data", err]);
            }
            emitter.emit("server-call-stop");
            fetchingData.value = false;
        };

        chartOptions.value = {
            chart: {
                id: reportfilename,
                type: "bar",
                zoom: {
                    enabled: false
                },
                foreColor: "black",
                toolbar: {
                    show: true
                }
            },
            colors: ["#E4CEB9", "#7396D0", "#F7B85E", "#DF5F5F", "#345EE4"],
            title: {
                text: reportTitle,
                style: {
                    fontSize: "14px",
                    fontWeight: "Bold"
                }
            },
            dataLabels: {
                enabled: true,
                style: {
                    fontSize: "10px",
                    fontWeight: "Normal",
                    colors: ["black"]
                },
                formatter: function(value) {
                    return Utilities.toCurrency(value);
                }
            },
            xaxis: {
                labels: {},
                categories: [],
                title: {
                    text: xAxisLabel,
                    fontWeight: "normal"
                }
            },
            yaxis: {
                title: {
                    text: yAxisLabel,
                    fontWeight: "normal"
                },
                labels: {
                    formatter: function(value) {
                        return Utilities.toCurrency(value);
                    }
                }
            }
        };

        series.value = [
            {
                name: "Small",
                data: []
            },
            {
                name: "Medium",
                data: []
            },
            {
                name: "Large",
                data: []
            },
            {
                name: "Jumbo",
                data: []
            },
            {
                name: "Free",
                data: []
            }
        ];

        const populateChart = () => {
            chartOptions.value = {
                xaxis: {
                    categories: dataReport.value.map((a) => a.source),
                    title: {
                        text: xAxisLabel,
                        fontWeight: "normal"
                    }
                }
            };

            // The five standard bucket sizes.
            const newSeries = [
                { name: "Small", data: dataReport.value.map((a) => a.small) },
                { name: "Medium", data: dataReport.value.map((a) => a.medium) },
                { name: "Large", data: dataReport.value.map((a) => a.large) },
                { name: "Jumbo", data: dataReport.value.map((a) => a.king) },
                { name: "Free", data: dataReport.value.map((a) => a.free) }
            ];

            // Bay "buckets" (duration tier + player count, e.g. "Short 1") are dynamic - one series each.
            const bayKeys = [];
            dataReport.value.forEach((row) => {
                Object.keys(row.bayBuckets ?? {}).forEach((k) => {
                    if (!bayKeys.includes(k)) bayKeys.push(k);
                });
            });

            // Sort by duration tier (Short, Standard, Long, Extended) then player count, matching the other reports.
            const durationNames = ["Short", "Standard", "Long", "Extended"];
            const bayKey = (label) => {
                const at = label.lastIndexOf(" ");
                return {
                    tier: at > 0 ? durationNames.indexOf(label.substring(0, at)) : -1,
                    players: at > 0 ? parseInt(label.substring(at + 1), 10) || 0 : 0
                };
            };
            bayKeys.sort((a, b) => {
                const ka = bayKey(a);
                const kb = bayKey(b);
                if (ka.tier >= 0 && kb.tier >= 0) return ka.tier !== kb.tier ? ka.tier - kb.tier : ka.players - kb.players;
                if (ka.tier >= 0) return -1;
                if (kb.tier >= 0) return 1;
                return a.localeCompare(b);
            });

            bayKeys.forEach((key) => {
                newSeries.push({ name: key, data: dataReport.value.map((a) => (a.bayBuckets ?? {})[key] ?? 0) });
            });

            series.value = newSeries;
        };

        return {
            onView,
            dataReport,

            chartOptions,
            series,
            onClose
        };
    }
};
</script>

<style scoped>
.report-modal {
    width: 90%;
    height: 70%;
    margin: 100px auto;
    background: white;
}
</style>
